export function roundToTwoPlaces(number) {
  return +(Math.round(number + 'e+2') + 'e-2')
}

export function addCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function fractionalDecimalDisplay(number) {
  return number === Number(number.toFixed(2)) ? number.toFixed(2) : number.toFixed(3)
}

export function calculatePriceWithBreaks(quantity, box) {
  const priceBreakElement = document.getElementById(`price_break_${box}`)
  if (!priceBreakElement) return 0
  
  const priceBreaks = JSON.parse(priceBreakElement.value)
  const uomElement = document.getElementById(`uom_name_${box}`)
  const spoolPutupElement = document.getElementById(`spool_putup_${box}`)
  
  const selectedUnit = uomElement?.value || spoolPutupElement?.value
  
  for (const breakItem of priceBreaks) {
    if (breakItem.unit === selectedUnit) {
      return findPriceForQuantity(breakItem.price_breaks, quantity)
    }
  }
  
  return 0
}

function findPriceForQuantity(priceBreaks, quantity) {
  for (let i = 0; i < priceBreaks.length; i++) {
    const currentBreak = priceBreaks[i]
    const nextBreak = priceBreaks[i + 1]
    
    if (quantity >= currentBreak.quantity) {
      if (!nextBreak || quantity < nextBreak.quantity) {
        return currentBreak.price
      }
    }
  }
  
  return 0
}
